import { useState, useEffect, useCallback } from "react";
import useApi from "./useApi";

export const useProductSearch = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchBy, setSearchBy] = useState("UNIVERSAL");
  const { request } = useApi();

  const COMPANY_CODE = localStorage?.getItem("companyCode") || "DOODDEMO";
  const API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : [];
  const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";

  const fetchProductData = useCallback(
    async (query, searchByValue, location = "A") => {
      const effectiveQuery = query?.trim() === "" ? "-" : query?.trim() || "-";
      const formattedQuery = effectiveQuery.replace(/\//g, "%2F");

      try {
        setLoading(true);
        const url = `${BASE_URL}/api/CRMStockList/${COMPANY_CODE}/${searchByValue}/${formattedQuery}/${location}/-`;
        const response = await request({ url, method: "GET", timeout: 5000 });
        setProducts(response || []);
      } catch (err) {
        console.error("Failed to fetch product data", err);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    },
    [BASE_URL, COMPANY_CODE],
  );

  useEffect(() => {
    if (!searchQuery && searchBy === "UNIVERSAL") return;
    fetchProductData(searchQuery, searchBy);
  }, [searchQuery, searchBy, fetchProductData]);

  return {
    products,
    loading,
    searchQuery,
    setSearchQuery,
    searchBy,
    setSearchBy,
    fetchProductData,
  };
};
